// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/artwork-tile/artwork-tile.component.scss
// module id = 442
// module chunks = 0